module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q6-lockup.b5a4fddc.png";